/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon32Regular = forwardRef('TimeClockMoveBackIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M18.179 5.218A11 11 0 0 0 6.202 11H9.5a1 1 0 1 1 0 2h-5A1.5 1.5 0 0 1 3 11.5V6a1 1 0 0 1 2 0v3.072a13 13 0 1 1-.905 12.15 1 1 0 1 1 1.831-.803A11 11 0 1 0 18.18 5.218Z" }),
        React.createElement("path", { d: "M15 8.75a1 1 0 0 1 1 1v5.264a1 1 0 0 0 .553.894l4.394 2.198a1 1 0 1 1-.894 1.788l-4.395-2.197A3 3 0 0 1 14 15.014V9.75a1 1 0 0 1 1-1Z" })));
});
